import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { ClientRelation, ClientType } from '../../../../core';
import { FullClient } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-full-data-participants-table',
    templateUrl: './full-data-participants-table.component.html',
    styleUrls: ['./full-data-participants-table.component.scss'],
})
export class FullDataParticipantsTableComponent extends BaseUI implements AfterViewInit, OnDestroy {
    public ClientRelation: typeof ClientRelation = ClientRelation;
    public ClientType: typeof ClientType = ClientType;

    @Input()
    isAdmin = false;

    @Input()
    isAdminPBC = false;

    @Input()
    isGDC = false;

    @Input()
    isLegalPerson = false;

    @Input()
    participants: FullClient[] = [];

    @Output()
    edit: EventEmitter<FullClient> = new EventEmitter();

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    onEdit(participant: FullClient) {
        this.edit.next(participant);
    }
}
